import React from 'react'
import { Box, IcoMoon, CloseIcon } from '@usap/uicomponents'
import Lightbox from '../../../../common/Lightbox'
import PrepaidShippingLabel from './PrepaidShippingLabel'
import OwnShippingLabel from './OwnShippingLabel'

export default function LightboxShippingLabel({
  shippingLabelLightboxInstruction,
  isDesktop,
  displayLightbox,
  setDisplayLightbox,
}) {
  if (!shippingLabelLightboxInstruction) {
    return null
  }
  const { id, returnAddress } = shippingLabelLightboxInstruction
  const shippingLabelDisplay = () => {
    if (id === 'prepaid-shipping-label') {
      return (
        <PrepaidShippingLabel isDesktop={isDesktop} />
      )
    }
    return (
      <OwnShippingLabel addressDisplay={returnAddress} isDesktop={isDesktop} />
    )
  }
  return (
    <Lightbox maxWidth="328px" isDisplay={displayLightbox}>
      <Box direction="row-reverse">
        <IcoMoon icon={CloseIcon} onClick={() => setDisplayLightbox(false)} color="#FFFFFF" />
      </Box>
      <Box background="#FFFFFF" pad="small">
        { shippingLabelDisplay() }
      </Box>
    </Lightbox>
  )
}
